import React, { Component } from 'react'
import arrowRight from '../img/right-arrow.svg'
import arrowLeft from '../img/left-arrow.svg'

export default class Error extends Component {
    render() {
        return (
            <div className="error">
                <div className="title">
                    <div className="title__img">
                        <img src={arrowLeft} height="25px" alt="arrow right"/>
                    </div>
                    <div className="title__heading">
                        <h1>404! The page not found</h1>
                    </div>
                    <div className="title__img">
                        <img src={arrowRight} height="25px" alt="arrow right"/>
                    </div>
                </div>
            </div>
        )
    }
}
